export enum EnvironmentName {
  LocalHost = 'localhost',
  Dev = 'dev',
  Qa = 'qa',
  Demo = 'demo',
  Uat = 'uat',
  Prod = 'prod',
  AvesdoDev = 'avesdo-dev'
}
